import type { Stakeholder } from "@/hooks/use-stakeholders";
import { cn } from "@/lib/utils";

interface ParticipantStackProps {
  participantIds: string[];
  stakeholders: Stakeholder[] | undefined;
  max?: number;
  className?: string;
}

export function ParticipantStack({
  participantIds,
  stakeholders,
  max = 4,
  className,
}: ParticipantStackProps) {
  if (participantIds.length === 0) return null;
  const byId = new Map(stakeholders?.map((s) => [s.id, s]) ?? []);
  const visible = participantIds.slice(0, max);
  const overflow = participantIds.length - visible.length;

  return (
    <div className={cn("flex -space-x-1.5", className)}>
      {visible.map((id) => {
        const s = byId.get(id);
        const initials = s?.initials ?? "?";
        const isClient = s?.org === "client";
        return (
          <span
            key={id}
            title={s ? `${s.name} (${s.role})` : "Unknown"}
            className={cn(
              "inline-flex h-6 w-6 items-center justify-center rounded-full text-[10px] font-semibold ring-2 ring-card",
              isClient ? "bg-nymbl-sky text-nymbl-navy" : "bg-nymbl-navy text-white",
            )}
          >
            {initials}
          </span>
        );
      })}
      {overflow > 0 && (
        <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-muted text-[10px] font-semibold text-foreground/70 ring-2 ring-card">
          +{overflow}
        </span>
      )}
    </div>
  );
}
